/* eslint-disable max-len */
import React from 'react';

import { Container } from '@components/Container';
import { Layout } from '@components/Layout';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'プライバシーポリシー',
    bannerTitle: 'プライバシーポリシー',
    content: `\
プライバシーポリシー及び個人情報保護に関する取扱いについて

エフシースタンダードロジックス株式会社並びに関連するグループ企業（以下「エフシーグループ」とする。）は、お客様に対して満足度の高いサービスを提供していく上で個人情報の適切な保護と取扱に関する基本方針（プライバシーポリシー）を定め、これを遂行する。

<b>
1  関係法令の遵守
</b>

エフシーグループは、個人情報の取扱いにおいて、関係法令、国が定める指針および当該プライバシーポリシーを定めた事項（以下「法令」とする。）を確実に遵守しなければならない。

<b>
2  個人情報の利用目的
</b>

エフシーグループは、個人情報について、国際総合物流を当該利用目的（以下「利用目的」という。）として特定するとともに、利用目的の達成に必要な範囲を超えた取扱いをしてはならない。

<b>
3  個人情報の取得
</b>

エフシーグループは、前項で特定した利用目的の達成において、適正かつ適法な手段により個人情報を取得するものとする。

<b>
4  個人情報の安全管理措置
</b>

エフシーグループは、提供された個人情報に関する漏洩、滅失または毀損を防止するため、適切な安全管理措置を講じ、当該個人情報はエフシーグループが定める管理者が適切に管理をしなければならず、データ管理については紙面、電磁的記録、保存媒体機器等によって保存され、安易に閲覧ができない措置を確実に実施する。

また保有するソフトウェアについて専門機関が認める企業より保守サービスを定期的に実施され、当該機器及びバージョンは最新の状態でセキュリティー対策が万全に維持された管理に努めなければならない。エフシーグループへ従事する従業者の全部並びに委託先における連携についても同項内容の全てを準ずるものとし、適切に管理者は監督しなければならない。

<b>
5  個人情報の第三者への提供
</b>

エフシーグループは、法令に基づく場合を除き、あらかじめお客様の同意を得ることなく、個人情報を第三者に対して提供してはならない。

なお、個人番号等の特定個人情報については、上記にかかわらず、法令で定める場合を除き、第三者への提供および用途外使用をしてはならないものとする。

<b>
6  個人情報の利用目的達成後の取扱い
</b>

エフシーグループは、お客様から受注した業務が遂行され目的が達成された時には、当該個人情報の処理について外部流失等の危険を防止するため慎重に取り扱わなければならない。

<b>
7  継続的改善
</b>

エフシーグループは、情報技術の発展や社会的要請の変化等を勘案し、個人情報保護のための管理体制および取組について、継続的に見直し、その改善に努めなければならない。

<b>
8  Cookie(クッキー)その他の技術の利用
</b>

当社サービスは、Cookie及びこれに類する技術を利用することがあります。これらの技術は、当社による当社サービスの利用状況等の把握に役立ち、サービス向上に資するものです。Cookieを無効化されたいユーザーは、ウエブプラウザの設定を変更することによりCookieを無効化することができます。但し、Cookieを無効化すると、当社サービスの一部の機能をご利用いただけなくなる場合があります。

<b>
【相談センター開設について】
</b>

<b>個人情報に関するお客様窓口の連絡先の開示</b>

エフシーグループは、保有するお客様の個人情報に関する取扱いについて

ご意見・ご要望がございましたら、下記相談センターへお問い合わせ頂けますよう

宜しくお願い申し上げます。


【お客様サービス相談センター：電話番号06-6266-8857】

受付時間  平日9:00～17:30

エフシースタンダードロジックス株式会社

〒541-0056

大阪市中央区久太郎町2丁目4番11号

クラボウアネックスビル6階

個人情報苦情・相談窓口責任者  磯上一夫  瀬崎吉子

令和2年9月10日  施行（改訂）
`,
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  title: {
    ...common.normalText,
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '42px',
    marginBottom: '6rem',
  },
  content: {
    ...common.normalText,
    whiteSpace: 'pre-wrap',
    '& b': {
      color: theme.palette.grey['800'],
    },
    color: theme.palette.grey['700'],
  },
}));

export const PrivacyPolicy: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <Layout title={strings.title} breadcrumbs={['/utilities/Dashboard', '/about/PrivacyPolicy']}>
      <Container>
        <div className={classes.title}>{strings.title}</div>
        <div className={classes.content} dangerouslySetInnerHTML={{ __html: strings.content }} />
      </Container>
    </Layout>
  );
};

export const meta: PageMeta = {
  title: strings.bannerTitle,
  order: 2,
};
